import * as React from 'react';
import { DashboardContent } from '../Components/Dashboard/DashboardContent';
import { Layout } from '../Components/Layout';
import { setDrawerContent, setPageContent } from '../Store/Layout/Actions';
import { Route, RouteComponentProps } from 'react-router-dom';
import {  IApplicationState, IConnectedReduxProps } from '../Store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { ILayoutState } from '../Store/Layout/Types';
import { DashboardDrawer } from '../Components/Sidebar/DashboardDrawer';
import { IElectionsState } from '../Store/Elections/Types';
import _ from 'lodash';
import { ElectionsPresContent } from '../Components/Elections/ElectionsPresContent';
import { ElectionsLegisContent } from '../Components/Elections/ElectionsLegisContent';
import { ElectionsRegionaleContent } from '../Components/Elections/ElectionsRegionaleContent';

interface IPropsFromState {
    layout: ILayoutState;
    elections: IElectionsState;
}

interface IPropsFromDispatch {
    setPageContent: typeof setPageContent;
    setDrawerContent: typeof setDrawerContent;
}

type AllProps =
    IPropsFromDispatch &
    IPropsFromState &
    RouteComponentProps<{}> &
    IConnectedReduxProps;

export class DashboardPage extends React.Component<AllProps> {

    public componentDidMount() {
        let componentToShow:any = DashboardContent;
        if (this.props.elections.isElectionChecked) {
            if (this.props.elections.isElectionPresedentielle) {
                componentToShow = ElectionsPresContent
            } 
            else if (this.props.elections.isElectionsLegislative) {
                componentToShow = ElectionsLegisContent
            }
            else componentToShow = ElectionsRegionaleContent
        }
        this.props.setPageContent(<Route component={componentToShow} />)

        this.props.setDrawerContent(<Route component={DashboardDrawer} />)
    }
    componentDidUpdate(prevProps: AllProps) {
        if (!_.isEqual(prevProps.elections.isElectionChecked, this.props.elections.isElectionChecked) ||
        !_.isEqual(prevProps.elections.isElectionPresedentielle, this.props.elections.isElectionPresedentielle)
        ) {
            let componentToShow:any = DashboardContent;
            if (this.props.elections.isElectionChecked) {
                if (this.props.elections.isElectionPresedentielle) {
                    componentToShow = ElectionsPresContent
                } else if (this.props.elections.isElectionsLegislative) {
                    componentToShow = ElectionsLegisContent
                }
                else componentToShow = ElectionsRegionaleContent
            }
            this.props.setPageContent(<Route component={componentToShow} />)
        }
    }
           
    public render(): React.ReactNode {

            return (                
                <Route component={Layout}/>
            );
    }
}

const mapStateToProps = ({ layout , elections}: IApplicationState) => ({
    layout,
    elections
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setPageContent: (c: React.ReactNode) => dispatch(setPageContent(c)),
    setDrawerContent: (c: React.ReactNode) => dispatch(setDrawerContent(c)),
});

export const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
